import {values} from 'lowscore'
import PaymentMethods from "./methods/index.js";
import PlaceHolderPaymentMethod from './methods/placeholder.jsx'
import * as gtmDataLayer from '../../../analytics/gtm/dataLayer.js'
import {
  FullPaymentOption,
  DepositPaymentOption,
  PlaceOnHoldPaymentOption,
  PaymentGatewayFull,
  PaymentGatewayDeposit,
  FakePaymentGatewayFull,
  FakePaymentGatewayDeposit,
  ZipMoneyMonthlyOption,
  PayMonthlyOption,
} from './options/index.js'

export default class PaymentOptions {
  constructor ({availablePaymentMethods, config, depositProminenceEnabled, paymentTab, standardPriceStrikeThroughAllowed}) {
    this.config = config
    this.paymentTab = paymentTab
    this.standardPriceStrikeThroughAllowed = standardPriceStrikeThroughAllowed

    this.setupAvailablePaymentOptions({availablePaymentMethods, depositProminenceEnabled, standardPriceStrikeThroughAllowed})

    this.updateEligible()
  }

  setupAvailablePaymentOptions ({availablePaymentMethods, depositProminenceEnabled, standardPriceStrikeThroughAllowed}) {
    availablePaymentMethods = (
      availablePaymentMethods || values(PaymentMethods)
    ).map(T => new T(this.paymentTab))

    this.paymentMethods = {
      eligible: availablePaymentMethods.filter(option => option.eligible()),
    }

    this.paymentMethods.selected = this.paymentTab.isPayPalEligible()
      ? new PlaceHolderPaymentMethod(this.paymentTab)
      : this.paymentMethods.eligible[0]

    this.payMonthly = new PayMonthlyOption(this.paymentTab)

    if (this.paymentTab.features.paymentGatewayEnabled) {
      if (this.config.environment === 'test') {
        this.availablePaymentOptions = [
          new FakePaymentGatewayFull(this.paymentTab),
          new FakePaymentGatewayDeposit(this.paymentTab),
        ]
      } else {
        this.availablePaymentOptions = [
          new PaymentGatewayDeposit(this.paymentTab),
          new PaymentGatewayFull(this.paymentTab),
        ]
      }
    } else {
      this.availablePaymentOptions = [
        new DepositPaymentOption(this.paymentTab, this.paymentMethods, depositProminenceEnabled),
        new FullPaymentOption(this.paymentTab, this.paymentMethods, standardPriceStrikeThroughAllowed),
      ]
    }

    this.availablePaymentOptions.push(
      this.payMonthly,
      new PlaceOnHoldPaymentOption(this.paymentTab)
    )
  }

  onadd () {
    gtmDataLayer.activateOptimize()
  }

  onupdate () {
    gtmDataLayer.activateOptimize()
  }

  toggleUplift (upliftEligible) {
    this.payMonthly.upliftEligible = upliftEligible
    this.updateEligible()
  }

  addZipMoneyMonthlyOption () {
    this.availablePaymentOptions.push(new ZipMoneyMonthlyOption(this.paymentTab))
    this.updateEligible()
  }

  updateEligible () {
    this.selected = undefined
    this.eligible = this.availablePaymentOptions.filter(option => option.eligible())

    if (!this.eligible.length) {
      throw new Error('no eligible payment options')
    }

    this.selected = this.eligible[0]
  }

  isOnHoldAvailable () {
    return this.eligible.find(opt => opt instanceof PlaceOnHoldPaymentOption)
  }
}